export default __webpack_public_path__ + "static/via-myetherwallet-f3f7c50ba713ef08d6b55efb2ca2fda4.png";